import { ArrowUpRightIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DiscordIcon } from "@/components/icons/discord";

const DISCORD_URL =
  "https://whop.com/joined/irreplaceable-engineer-lab/discord-Odzw6laOGxpUxL/app/";

export function DiscordJoinBanner() {
  return (
    <section
      role="region"
      aria-labelledby="discord-banner-title"
      className="rounded-xl border bg-card px-5 py-4 shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex items-start gap-4 sm:items-center">
          <div
            aria-hidden
            className="flex size-10 shrink-0 items-center justify-center rounded-xl border bg-accent"
          >
            <DiscordIcon className="size-5 text-foreground" />
          </div>

          <div className="min-w-0 flex-1">
            <h3
              id="discord-banner-title"
              className="font-semibold leading-tight"
            >
              Join the Irreplaceable Engineer Lab on Discord
            </h3>
            <p className="mt-1 text-sm text-muted-foreground">
              Get personalized feedback on your reading and connect with a
              community of senior engineers.
            </p>
          </div>
        </div>

        <div className="sm:ml-auto sm:shrink-0">
          <Button asChild size="sm" className="w-full sm:w-auto">
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Join the Irreplaceable Engineer Lab Discord (opens in new tab)"
            >
              Join Discord
              <ArrowUpRightIcon />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
